module.exports = __webpack_public_path__ + "static/media/flow.68ae752b.png";